import gql from 'graphql-tag';

export const login = gql`
mutation loginApi($details: LoginInput!) {
    login_api(details: $details) {
      id
      accessToken
      refreshToken
      name
      email
      phone
      logo
      status
      message
      profile_completed
      payment_completed
      profile_image
      type
      address
      directory_category_id
      profession_type
      second_hand
      business_name
      abn_number
      gender
      sell_products
      dashboard_permissions
      plan_id
      payment_status
      subscription_id
      subscription_permissions

    }
  }
`;


export const signUp = gql`

mutation signUp($signUpObj: clients_insert_input!) {
  insert_clients_one(object: $signUpObj) {
    id
    email
    phone
    client_verification_key
    type
  }
}

`;

export const CHECK_EMAIL = gql`
  query checkEmail($email: String!) {
    clients(where: { email: { _ilike: $email } }) {
      id
      name
      email
    }
  }
`;


export const updateUser = gql`
mutation updateUser($id: uuid!, $updateObj: clients_set_input!) {
  update_clients_by_pk(pk_columns: {id: $id},_set: $updateObj) {
    id
    email
    payload
  }
}
`;


export const getUserSubscrptions = gql`
query getUserSubscrptions($id:uuid!){
  user_subscriptions(where:{
    _or:[{
      dental_supplier_id: {_eq: $id}
    },{
      dental_practice_id: {_eq: $id}
    },{
      dental_professional_id: {_eq: $id}
    }]
  }){
    id
    created_at
    expires_at
    subscription_plan_id
    dental_supplier_id
    dental_professional_id
    dental_practice_id
    payment_status
  }
}
`;
